// extracted by mini-css-extract-plugin
export var contentBody = "_ds-9";
export var headerImage = "_ds-2";
export var imageButton = "_ds-7";
export var imageButtonIcon = "_ds-8";
export var imageHeader = "_ds-4";
export var imageHeaderText = "_ds-5";
export var imageOverlay = "_ds-3";
export var imageTitle = "_ds-6";
export var imageWrapper = "_ds-1";
export var taskList = "_ds-a";
export var widget = "_ds-0";